import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { AuthenticationService } from '@app/services/authentication.service';
import { ModalResult, ConfirmOtpModalComponent as ModalComponent } from './confirm-otp-modal.component';

@Injectable({ providedIn: 'root' })
export class ConfirmOtpModalService {
  constructor(private modalService: ModalService, private authenticationService: AuthenticationService) {}

  open(properties: { logoutOnDismiss?: boolean } = {}, options: NgbModalOptions = {}) {
    if (properties.logoutOnDismiss) {
      (options as NgbModalOptions).beforeDismiss = () => {
        this.authenticationService.logout().subscribe();
        return true;
      };
    }

    return this.modalService.open<ModalResult>(ModalComponent, null, options);
  }
}
